import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUser } from '../../App';
import QuestionsManager from './QuestionsManager';
import UsersManager from './UsersManager';
import ResultsViewer from './ResultsViewer';
import ReportsManager from './ReportsManager';

const TABS = [
  { id: 'questions', label: '📝 Vragen' },
  { id: 'reports',   label: '⚠️ Meldingen' },
  { id: 'users',     label: '👥 Gebruikers' },
  { id: 'results',   label: '📊 Resultaten' },
  { id: 'quiz',      label: '🎯 Quiz spelen' },
];

export default function AdminPanel() {
  const [activeTab, setActiveTab] = useState('questions');
  const navigate = useNavigate();
  const user = getUser();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="admin-logo">
          <span>HVAC Quiz</span>
          <span className="admin-logo-badge">Admin</span>
        </div>
        <nav className="admin-nav">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              className={`nav-item ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => tab.id === 'quiz' ? navigate('/') : setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </nav>
        <div className="admin-user">
          <div className="admin-user-name">{user?.name || user?.email}</div>
          <div className="admin-user-email" style={{ fontSize: '0.75rem', opacity: 0.6 }}>{user?.email}</div>
          <button className="btn-logout-sidebar" onClick={handleLogout}>Uitloggen</button>

        </div>
      </aside>

      {/* Main content */}
      <main className="admin-main">
        {activeTab === 'questions' && <QuestionsManager />}
        {activeTab === 'reports'   && <ReportsManager />}
        {activeTab === 'users'     && <UsersManager />}
        {activeTab === 'results'   && <ResultsViewer />}
      </main>
    </div>
  );
}
